import { useCallback, useEffect, useRef, useState } from "react";

export default function useSleepTimer(onExpire) {
  const [deadline, setDeadline] = useState(null);
  const [remaining, setRemaining] = useState(0);
  const [finished, setFinished] = useState(false);
  const expireRef = useRef(onExpire);
  expireRef.current = onExpire;

  const cancel = useCallback(() => {
    setDeadline(null);
    setRemaining(0);
    setFinished(false);
  }, []);

  const start = (minutes) => {
    setDeadline(Date.now() + minutes * 60 * 1000);
    setRemaining(minutes * 60);
    setFinished(false);
  };

  useEffect(() => {
    if (deadline === null) return;
    let expired = false;
    const tick = () => {
      if (expired) return;
      const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      setRemaining(seconds);
      if (seconds === 0) {
        expired = true;
        setDeadline(null);
        setFinished(true);
        expireRef.current();
      }
    };
    tick();
    const interval = setInterval(tick, 1000);
    // Recheck elapsed time when returning to a backgrounded browser tab.
    document.addEventListener("visibilitychange", tick);
    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", tick);
    };
  }, [deadline]);

  return { start, cancel, remaining, finished, isRunning: deadline !== null };
}
